import { first } from 'rxjs/operators';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { SacPurposeDialogComponent } from './../../../../common/sac-purpose/components/sac-purpose-dialog/sac-purpose-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild, Renderer2, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IGTM, ISystemEvent } from '../../../../shared/models/events.model';
import { CampaignService, EventsService, UtilService } from '../../../../shared/services';
import { RecaptchaComponent } from 'ng-recaptcha';
import { OCCUPATION_LIST, QUALIFICATION_LIST } from '../../objects/basic-info.model';
import { BrandSurveyData } from 'src/app/shared/models/brand-survey';
import { StartAFrUrls } from 'src/app/shared/models/start-fr-urls';

declare const dataLayer: any[];

@Component({
  selector: 'app-basic-detail',
  templateUrl: './basic-detail.component.html',
  styleUrls: ['./basic-detail.component.scss']
})
export class BasicDetailComponent implements OnInit, OnDestroy {

  basicForm: FormGroup;
  amount_requested: FormControl;
  title: FormControl;
  relation: FormControl;
  beneficiaryname: FormControl;
  ngo: FormControl;
  cause_id: FormControl;
  captcha: FormControl;
  survey: FormControl;
  showCaptcha = true;
  frType;
  allCauses = [];
  isLoading = false;

  parentCauses = [
    { label: 'Myself', id: 20, value: 'myself', cause: 'Personal' },
    { label: 'Family Member', id: 20, value: 'family', cause: 'Personal' },
    { label: 'Friend', id: 20, value: 'friend', cause: 'Personal' },
    { label: 'Pet or Animal', id: 20, value: 'pet', cause: 'Personal' },
    { label: 'Colleague', id: 20, value: 'colleague', cause: 'Personal' },
    { label: 'Community', id: 20, value: 'community', cause: 'Personal' },
    { label: 'Other', id: 20, value: 'other', cause: 'Personal' },

  ];
  @Input() info;
  @Input() draft;
  @Input() causes: any[];
  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

  ngos: any[] = [];
  parentCauseId;
  selectedSurvey;
  beneficiaryRel;
  captchaRes;
  show = {
    beneficiaryname: false,
    ngo: false
  };
  type;
  userType;
  ngoId;
  mergedCause = [];
  campaignerPhone: FormControl;
  askCampaignerPhone = true;
  extn;

  qualification: FormControl;
  occupation: FormControl;
  qualificationList = QUALIFICATION_LIST;
  occupationList = OCCUPATION_LIST;
  brandSurveyData = BrandSurveyData;
  startAFrUrls = StartAFrUrls;

  subs = [];

  constructor(
    private router: Router,
    private actRoute: ActivatedRoute,
    public util: UtilService,
    public campaignService: CampaignService,
    private events: EventsService,
    private vars: VariablesService,
    private renderer: Renderer2,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: any
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.initForm();
    this.getPhoneExtn();
    this.frType = this.actRoute.snapshot.queryParams['type'];
    this.setCampaignType(this.frType);
    this.userType = this.util.getUser()?.user?.user_type;
    this.getCampaignType();
  }

  private setCampaignType(data) {
    if (data) {
      this.vars.campaignPurpose = data;
      this.parentCauseId = null;
      this.causes = undefined;
      this.cause_id.reset();
      if (data === 'medical') {
        this.router.navigate([this.startAFrUrls.medical], {queryParamsHandling: 'merge'});
      } else if (data === 'ngo') {
        this.frType = 'ngo';
        this.toggleControl('ngo');
        this.relation.patchValue('ngo');
        this.parentCauseId = 48;
        const entity_type = this.actRoute.snapshot.queryParams['entity_type'];
        const entity_id = this.actRoute.snapshot.queryParams['entity_id'];
        if (entity_type === 'ngo') {
          this.ngo.setValue(this.util.getUserData()?.fname);
          this.onNgoSelect({ value: entity_id });
        }
      } else {
        this.frType = 'other';
        // this.toggleControl('beneficiaryname');
        this.relation.patchValue('');
      }
    } else {
      this.frType = 'other';
    }
  }

  getPhoneExtn() {
    this.util.number$.subscribe(res => this.extn = res.extn);
  }

  listener() {
    this.renderer.listen('window', 'load', () => {
      if (this.showCaptcha) {
        this.captchaRef.execute();
      }
    });
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.vars.draftObs.pipe(first()).subscribe((res) => {
      this.draft = res;
      this.checkForUpdateOnInit();
      // this.vwoPush();
    });
  }
  /**Get the type of the campaign */
  getCampaignType() {
    this.util.campaignType$.subscribe((res) => {
      if (res) {
        this.type = res;
      }
    });
  }

  /**
   * Init the form
   */
  initForm() {
    this.basicForm = new FormGroup({
      amount_requested: this.amount_requested = new FormControl('', [Validators.required, Validators.min(2000), Validators.max(50000000)]),
      relation: this.relation = new FormControl('', Validators.required),
      title: this.title = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(75)]),
      cause_id: this.cause_id = new FormControl('', [Validators.required]),
      campaignerPhone: this.campaignerPhone = new FormControl('', [Validators.required]),
      captcha: this.captcha = new FormControl('', []),
      survey: this.survey = new FormControl('', [Validators.required]),
      qualification: this.qualification = new FormControl('', [Validators.required]),
      occupation: this.occupation = new FormControl('', [Validators.required])
    });
    const userData = this.util.getUserData();
    if (userData?.phone_1) {
      this.askCampaignerPhone = false;
      this.basicForm.removeControl('campaignerPhone');
    }
  }
  /**Add control dynamicaly */
  addControl(name: string, control: FormControl) {
    this.basicForm.addControl(name, control);
  }
  /**remove control */
  removeControl(control: string) {
    this.basicForm.removeControl(control);
  }
  public resolved(captchaResponse: string) {
    // if (captchaResponse) {
    //   this.captcha.setValue(captchaResponse);
    //   this.captcha.setErrors(null);
    // } else {
    //   this.captcha.setErrors({'failed': true});
    // }
    this.captcha.setValue(captchaResponse);
  }
  /**for user realtion */
  checkRelation() {
    if (this.userType === 'ngo') {
      this.relation.setValue(48);
      this.type = 'Ngo';
      this.toggleControl('ngo');
      this.ngo.setValue(this.util.getUserData()?.fname);
      this.ngo.disable();
      this.router.navigate([], { queryParams: { type: this.type }, queryParamsHandling: 'merge' });
    }
  }
  /**Select relation */
  selectRelation(event) {
    for (const item of this.parentCauses) {
      if (item.value === event) {
        this.util.campaignType.next(item.value === 'ngo' ? 'Ngo' : item.cause);
      }
    }
    this.router.navigate([], { queryParams: { type: this.type }, queryParamsHandling: 'merge' });
    const relId: string = event;
    this.beneficiaryRel = relId;
    this.causes = undefined;
    if (relId === 'myself') {
      this.removeControls();
    } else {
      this.toggleControl('beneficiaryname');
    }
    this.getMergedCauses();
  }
  /**toggle controls between ngo and beificiary */
  toggleControl(controlName: string) {
    if (controlName === 'beneficiaryname') {
      this[controlName] = new FormControl('', [Validators.required, Validators.pattern(/^.{3,}[a-z ,  .'-]+$/i)]);
    } else {
      this[controlName] = new FormControl('', [Validators.required]);
    }
    const toggledControl = controlName === 'ngo' ? 'beneficiaryname' : 'ngo';
    this.removeControl(toggledControl);
    this.addControl(controlName, this[controlName]);
  }
  removeControls() {
    this.removeControl('beneficiaryname');
    this.removeControl('ngo');
  }
  /**On ngo input */
  onNgoInput(event) {
    if (event) {
      this.getNGOs(event);
    }
  }
  /**On NGO Select */
  onNgoSelect(event) {
    if (event) {
      this.ngoId = event.value;
      this.getCausesById(event.value);
      if (event.label) {
        this.ngo.setValue(event.label);
        this.basicForm.patchValue({ ngo: event.label });
      }
    } else {
      this.causes = undefined;
      this.cause_id.reset();
      this.ngo.setValue('');
    }
  }
  /**Submit button click mock */
  submitButton() {
    // this.captchaRef.execute();
    this.document.getElementById('submitBtn1').click();
  }
  /**Submit form */
  basic() {
    if (this.basicForm.valid) {
      if (this.frType === 'ngo' && !this.ngoId) {
        document.getElementById('ngoSelectInput')?.focus();
        this.basicForm.get('ngo')?.markAsTouched();
        return;
      }
      this.isLoading = true;
      if (this.parentCauseId === null || !this.parentCauseId) {
        this.parentCauseId = 48;
      }
      const payload = {
        'title': this.title.value,
        'amount_requested': this.amount_requested.value,
        'cause_id': this.cause_id.value,
        'parent_cause_id': this.parentCauseId,
        'g-recaptcha-response': this.captcha.value,
        'qualification': this.qualification.value,
        'occupation': this.occupation.value
      };

      if (this.frType === 'ngo') {
        payload['entity_details_id'] = this.ngoId;
        if (this.campaignService.micrositeCampaigns.entity_type === 'events') {
          payload['event_entity_details_id'] = this.campaignService.micrositeCampaigns.entity_id;
        }
      } else if (this.frType !== 'ngo' && this.relation.value !== 'myself') {
        payload['beneficiaryname'] = {
          'info_type': 'beneficiary_name',
          'entity_type': 'campaign',
          'info_1': this.beneficiaryname.value,
        };
        payload['beneficiaryrelation'] = {
          'info_type': 'beneficiary_relation',
          'entity_type': 'campaign',
          'info_1': this.beneficiaryRel,
        };
      }
      payload['brandsurvey'] = {
        'info_type': 'brand_survey',
        'entity_type': 'campaign',
        'info_1': this.selectedSurvey,
      };
      this.checkWhichServiceToCall(payload);
    } else {
      this.util.checkValidForm(this.basicForm);
    }
  }
  checkWhichServiceToCall(payload) {
    let draftId = this.actRoute.snapshot.queryParams['did'];
    if (!draftId) {
      const sessDraft = this.util.storage.getFromSession('draft');
      if (sessDraft) {
        draftId = sessDraft?.id;
      }
    }
    !draftId ? this.createCampaign(payload) : this.updateCampaign(payload, draftId);
  }
  /**Check for update */
  checkForUpdateOnInit() {
    const id = this.actRoute.snapshot.queryParams['did'];
    if (id && this.draft) {
      if (this.draft.cause_id === 59) {
        this.setCampaignType('medical');
      } else if (this.draft.parent_cause_id === 48) {
        this.setCampaignType('ngo');
      } else {
        this.setCampaignType('other');
      }
      this.patchForm(this.draft);
    }
  }
  /**Patch form */
  patchForm(data) {
    this.basicForm.patchValue({
      'title': data.title,
      'amount_requested': data.amount_requested,
      'cause_id': data.cause_id,
      'qualification': data?.owner?.qualification?.info_1 || '',
      'occupation': data?.owner?.occupation?.info_1 || '',
      survey: data?.brandsurvey?.info_1
    });
    this.parentCauseId = data?.parent_cause_id;
    this.showCaptcha = false;
    if (data.parent_cause_id === 48) {
      this.relation.patchValue('ngo');
      // this.toggleControl('ngo');
      this.ngo.patchValue(data?.beneficiary?.fname);
      this.onNgoSelect({ value: data.entity_details_id, label: data?.beneficiary?.fname });
    } else if (data.parent_cause_id === 20 || data.parent_cause_id === 49) {
      if (data.beneficiaryrelation && data.beneficiaryrelation.info_1.match('friend|family|pet')) {
        this.relation.patchValue(data.beneficiaryrelation.info_1);
        this.toggleControl('beneficiaryname');
        this.beneficiaryname.patchValue(data.beneficiaryname.info_1);
      } else {
        this.relation.patchValue('myself');
      }
    }
    this.relation.disable();
    this.parentCauseId = data?.parent_cause_id;
  }
  /**Create campaign
   * @param payload required data for creating campaign
   */
  createCampaign(payload) {
    this.campaignService.createCampaign(payload).subscribe((res: any) => {
      if (this.askCampaignerPhone) { // Update campaigner phone number
        const payload2 = { 'owner': { 'phone_1': this.campaignerPhone.value, 'extension': this.extn } };
        this.campaignService.updateCampaign(payload2, res.data.id).subscribe(next => {
          this.updateCampaignerPhoneInStorage();
          this.getDraftById(res.data.creator_entity_details_id, res.data.id, this.type);
        });
      } else {
        this.getDraftById(res.data.creator_entity_details_id, res.data.id, this.type);
      }
      this.gtmPush(res.data);
      this.sendSystemEvent(res.data);
      if (this.captchaRef) {
        this.captchaRef.reset();
      }
      this.showCaptcha = false;
      this.isLoading = false;
    });
  }
  getDraftById(entityId, draftId, type) {
    this.campaignService.getCampaignDraft(draftId).subscribe((res: any) => {
      this.draft = res.data;
      this.util.storage.checkFromSession('draft', this.draft);
      this.sendDraftLead();
      // this.patchForm(res.data);
      if (this.frType === 'ngo') {
        this.ngo.disable();
      } else {
        this.relation.disable();
      }
      this.vars.draftObs.next(res.data);
      this.util.navigateToForm('image', type, this.draft.id);
    });
  }
  /**Update Campaign
   * @param payload required data for updating campaign
  */
  updateCampaign(payload, id) {
    if (this.askCampaignerPhone) {
      payload['owner'] = { 'phone_1': this.campaignerPhone.value, 'extension': this.extn };
      this.updateCampaignerPhoneInStorage();
    }
    this.campaignService.updateCampaign(payload, id).subscribe((res: any) => {
      // this.captchaRef.reset();
      this.isLoading = false;
      this.util.addObject(res.data, this.draft);
      this.vars.draftObs.next(this.draft);
      this.util.navigateToForm('image', this.type, this.draft.id);
    });
  }
  /**Get the merged causes of personal and creative */
  getMergedCauses(id?) {
    this.campaignService.getMergedCauses().subscribe((res: any) => {
      /** Concat merged causes into one array */
      this.mergedCause = [].concat(res.data.causes[0].child, res.data.causes[1].child);
      /** Removing Medical cause from merged causes */
      this.mergedCause = this.mergedCause.filter((cause) => cause.id !== 59);
      /** Sort array alphabetically */
      this.mergedCause.sort(function (a, b) {
        if (a.info_1 < b.info_1) { return -1; }
        if (a.info_1 > b.info_1) { return 1; }
        return 0;
      });
      this.causes = this.util.setArray(this.mergedCause, 'id', 'info_1');
    });
  }
  /**Get the causes */
  // getCauses(id) {
  //   this.campaignService.getCauses(id).subscribe((res: any) => {
  //     this.causes = this.util.setArray(res.data.child, 'id', 'info_1');
  //   });
  // }
  /**Get the causes */
  getCausesById(id) {
    this.campaignService.getCausesByNGO(id).subscribe((res: any) => {
      this.cause_id.reset();
      this.causes = this.util.setArray(res.data, 'cause_id', 'info_1');
    });
  }
  /**Get the NGOs */
  getNGOs(name?: string) {
    this.campaignService.getNGOs(name).subscribe((res: any) => {
      this.ngos = this.util.setArray(res.data.data, 'id', 'full_name');
    });
  }
  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent(data) {
    const payload: ISystemEvent = {
      eventName: 'start_a_campaign_step1_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step1',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(data.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (data?.id) {
      payload.event_type_id = +data?.id;
    }

    this.events.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush(data) {
    const dataPush: IGTM = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: data.parent_cause_name,
      eventLabel: 'step1_completed',
      Campaign_cause_id: data.cause_id,
      Campaign_id: Number(data.draftid),
      Campaign_Type: data.parent_cause_name
    };
    this.events.gtmPush(dataPush);
  }

  private updateCampaignerPhoneInStorage() {
    if (this.askCampaignerPhone) {
      const phone = {
        extension: this.extn,
        phone_1: this.campaignerPhone.value
      };
      const user = this.util.getUser();
      const userdata = this.util.getUserData();
      user.user.entity = { ...user.user.entity, ...phone };
      this.util.setUser(user);
      this.util.setUserData({ ...userdata, ...phone });
    }
  }

  openChangePurpose() {
    const dialogRef = this.dialog.open(SacPurposeDialogComponent, {
      panelClass: 'sac-purpose-changer',
      data: {
        frType: this.frType,
        showWarningText: true
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data) {
        this.frType = result.data;
        this.setCampaignType(this.frType);
      }
    });
  }

  onCauseSelect(data) {
    if (!this.parentCauseId) {
      const selectedCause: any = this.mergedCause.filter(cause => cause.id === data);
      this.parentCauseId = selectedCause[0].parent_cause_id;
    }
  }

  onSurveySelect(data) {
    this.selectedSurvey = data;
  }

  sendDraftLead() {
    const payload: any = {
      type: 'P - Draft campaign (Step 1)',
      subject: 'Draft campaign',
      goal_amount: this.amount_requested.value,
      relation: this.relation.value,
      hear_about_from: this.selectedSurvey,
      parent_cause_id: this.parentCauseId,
      cause_id: this.cause_id?.value,
      cause_name: this.draft?.cause?.info_1,
      CID: this.draft?.id
    };
    if (this.basicForm.get('qualification') && this.basicForm.get('occupation')) {
      payload['qualification'] = this.qualification.value;
      payload['employment_status'] = this.occupation.value;
    }
    this.events.sendLead(payload);
  }

  /**vwo push */
  // vwoPush() {
  //   const dataPush: IVWO = {
  //     event_name: 'pageView',
  //     event_type: 'campaign',
  //     event_type_id: this.draft.id,
  //     page_name: 'start_campaign'
  //   };
  //   this.events.vwoPush(dataPush);
  // }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
